module.exports = __webpack_public_path__ + "img/logo@2x.2af41e28.png";